// extracted by mini-css-extract-plugin
module.exports = {"container":"PanelInfo_container__2Vyfc"};